module.exports = __webpack_public_path__ + "img/verypoor.f13035d4.svg";